const filterCategory = (products, filterBy) => {
  if (filterBy === 'All') {
    return products;
  }

  return products.filter((product) => {
    return product.metadata.category === filterBy;
  });
};

export default filterCategory;
